import PropTypes from "prop-types";

import { actionNames, actionPrefixes, objectTypes } from "@newsela/snitch";
import BoltIcon from "@/icons/BoltIcon";
import StandaloneReadAloudButton from "../utils/StandaloneReadAloudButton";
import PowerWordLiteLockVeil from "./PowerWordLiteLockVeil";
import {
  boltIconCss,
  definitionBodyCss,
  headerCss,
  headerWrapperCss,
  readAloudIconCss,
  readAloudButtonOverrideCss,
  powerWordCss,
  powerWordWrapperCss,
} from "./PowerWordPopoutBody.style";

const propTypes = {
  currentFontSize: PropTypes.string,
  contentId: PropTypes.string,
  isLiteNonStudent: PropTypes.bool.isRequired,
  powerWord: PropTypes.string,
  powerWordId: PropTypes.string,
  wordDefinition: PropTypes.string,
};

const PowerWordPopoutBody = ({
  contentId,
  currentFontSize,
  isLiteNonStudent,
  powerWord,
  powerWordId,
  wordDefinition,
}) => {
  const readAloudText = `${powerWord}. ${wordDefinition || ""}`;
  const readAloudEventProperties = {
    objectType: objectTypes.articleWord,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.start,
    streamProperties: {
      content_type: "Article",
      description: "Power Word Read Aloud Initiated",
      content_id: contentId,
      object_id: powerWordId,
    },
  };

  const content = (
    <>
      <div css={powerWordWrapperCss}>
        <h3 css={powerWordCss(currentFontSize)}>{powerWord}</h3>
        <StandaloneReadAloudButton
          dataProps={{
            "data-qa-selector": "power_word_read_aloud_button",
          }}
          text={readAloudText}
          iconCss={readAloudIconCss(currentFontSize)}
          buttonOverrideCss={readAloudButtonOverrideCss}
          eventProperties={readAloudEventProperties}
          powerWord={powerWord}
        />
      </div>
      <div css={definitionBodyCss(currentFontSize)}>{wordDefinition}</div>
    </>
  );

  // We still need to track the close event, but the Angelou TooltipDialog
  // doesn't presently support this
  // const closeButtonEventProperties = {
  //   objectType: 'ArticleWord',
  //   actionName: 'Finish',
  //   actionPrefix: 'Cancel',
  //   streamProperties: {
  //     content_type: 'Article',
  //     description: 'Power Word Definition Popout Closed',
  //     content_id: contentId,
  //     object_id: powerWordId,
  //   }
  // };

  return (
    <div>
      <div css={headerWrapperCss}>
        <BoltIcon css={boltIconCss(currentFontSize)} />
        <h2 css={headerCss(currentFontSize)}>power word</h2>
      </div>
      {isLiteNonStudent ? (
        <PowerWordLiteLockVeil currentFontSize={currentFontSize} />
      ) : (
        content
      )}
    </div>
  );
};

PowerWordPopoutBody.propTypes = propTypes;

export default PowerWordPopoutBody;
